import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"
import { Link } from "react-router-dom"

export const GridContainer = styled.div`
  display: none;
  text-align: center;
  align-items: center;
  gap: 18px;

  ${(props) =>
    !props.homePage &&
    css`
      opacity: 0.4;
      transition: opacity 0.2s ease-in-out;

      a {
        color: #aaaaaa;
      }

      &:hover {
        opacity: 1;

        a {
          color: ${(props) => props.theme.colors.primary};
        }
      }
    `}

  ${(props) =>
    !!props.mobileOnly &&
    css`
      display: flex;
      justify-content: center;
    `}

  ${breakpoint("desktop")`
    gap: 0;
    grid-template-columns: repeat(6, 105px);
    width: 100%;

    ${(props) =>
      !!props.mobileOnly &&
      css`
        display: none;
      `}
    ${(props) =>
      !!props.desktopOnly &&
      css`
        display: grid;
      `}
  `}
`

export const Grid = styled.div`
  position: relative;

  &:nth-child(n + 2)::after {
    ${breakpoint("desktop")`
      content: "";
      height: 1.75rem;
      width: 1px;

      position: absolute;
      left: 0;
      top: 0.5rem;

      background-color: #dddddd;
  `}
  }

  &:nth-child(1)::after {
    ${breakpoint("desktop")`
      display: none;
    `}
  }

  ${(props) =>
    props.desktopOnly &&
    css`
      display: none;
    `}

  ${(props) =>
    props.desktopOnly &&
    breakpoint("desktop")`
    display: block;
  `}
`

export const CounterLink = styled(Link)`
  color: ${(props) => props.theme.colors.primary};
  font-weight: 500;
  font-size: 1rem;
  margin: 0 0 5px 0;
  text-decoration: none;

  ${breakpoint("desktop")`
    font-size: 1.125rem;
    `}
`

export const Counter = styled.span`
  color: ${(props) => props.theme.colors.primary};
  font-weight: 500;
  font-size: 1rem;
  margin: 0 0 5px 0;
  text-decoration: none;

  ${breakpoint("desktop")`
    font-size: 1.125rem;
    `}
`

export const State = styled.p`
  color: #aaaaaa;
  font-weight: 500;
  font-size: 0.6rem;
  margin: 0;
  text-align: center;

  ${breakpoint("desktop")`
    font-size: 0.75rem;
    `}
`

export const Header = styled.p`
  color: #aaaaaa;
  font-size: 1.125rem;
  font-weight: 400;
`
